import React, { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@shared/context/AuthContext';

export interface AdminGuardProps {
  children: ReactNode;
}

/**
 * AdminGuard component that guards routes requiring admin privileges.
 * Redirects to dashboard if user is not an admin.
 */
export const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isAdmin = user.role?.toLowerCase() === 'admin';
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
